import type { Links } from '../../interfaces/offers';

interface GetEducationLinksParams {
  item: any;
}

const EducationalLinkParams = {
  urlId: 'url_id',
  url: 'url',
  affUnique3: 'aff_unique3',
};

export const getEducationLinks = ({ item }: GetEducationLinksParams): Links => {
  const { advertising, link, hasOffersUrlId } = item;

  if (!advertising) {
    return {};
  }

  const paramsMap = {
    [EducationalLinkParams.urlId]: hasOffersUrlId,
    [EducationalLinkParams.url]: link,
    [EducationalLinkParams.affUnique3]: link,
  };

  try {
    const displayLink = new URL(advertising.monetization.pixels.display);
    const clickLink = new URL(advertising.monetization.pixels.click);

    const paramInLink = Object.values(EducationalLinkParams).find((param) => clickLink.searchParams.has(param));

    clickLink.searchParams.set(paramInLink, paramsMap[paramInLink]);
    displayLink.searchParams.set(paramInLink, paramsMap[paramInLink]);

    return {
      displayLink: displayLink.toString(),
      clickLink: clickLink.toString(),
    };
  } catch (error) {
    console.error(error);
  }
};
